// import { combineReducers } from "redux";

const defaultUsers = {};
const users = (state = defaultUsers, action) => {
  switch (action.type) {
      case 'GET_USERS_SUCCESS':
      case 'GET_USERS_BY_COMPANY_SUCCESS':
          return { ...action.users };
      default:
          return state;
  }
};

export default users;
// export default combineReducers({
//     users
// })
